import { Outlet } from 'react-router-dom';
import Header from '../components/layouts/Header';
import Sidebar from '../components/layouts/Sidebar';

const RootPage = () => {
    return (
        <div className="w-full h-screen overflow-hidden">
            <div className="flex h-full">
                <Sidebar />
                <div className="flex-1 h-full overflow-y-auto">
                    <Header />
                    <div className="px-8 py-8 bg-gray-100 min-h-full">
                        {/* the routed component will get rendered as the outlet */}
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RootPage;
